import { User } from '@cliengo/mfe-utils/types';
import { Avatar, Typography, useTheme } from '@mui/material';

import { Flex } from '@/components/utils';

interface PopoverHeaderProps {
  user: User;
}

export const PopoverHeader = ({ user }: PopoverHeaderProps) => {
  const { palette } = useTheme();

  return (
    <Flex
      gap=".33rem"
      sx={{
        pb: '.5rem',
        borderBottom: `1px solid ${palette.divider}`,
        alignItems: 'center',
      }}
    >
      <Avatar
        alt={user.name}
        src={user.imageUrl}
        sx={{ width: 46, height: 46 }}
      />
      <Flex column>
        <Typography sx={{ fontSize: '12px', height: '23px' }} variant="body1">
          {user.name}
        </Typography>
        <Typography
          sx={{
            fontSize: '10px',
            maxWidth: '136px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          variant="body2"
        >
          {user.email}
        </Typography>
      </Flex>
    </Flex>
  );
};
